

























import vue from "vue";

import ChatText from "@tt-app/components/exercise/common/ChatText.vue";
import ExerciseHtmlText from "@tt-app/components/exercise/consolidated/exercise/body/ExerciseHtmlText.vue";
import ExerciseImage from "@tt-app/components/exercise/consolidated/exercise/body/ExerciseImage.vue";
import ExercisePlainText from "@tt-app/components/exercise/consolidated/exercise/body/ExercisePlainText.vue";
import ExerciseSeparator from "@tt-app/components/exercise/consolidated/exercise/body/ExerciseSeparator.vue";
import ExerciseTextArea from "@tt-app/components/exercise/consolidated/exercise/body/ExerciseTextArea.vue";

interface Computed {
  dynamicComponent: string;
  dynamicProps: any;
  headerElements: any[];
  reviewProblemUuid: string | undefined;
  recursiveComponent: boolean;
}

interface Props {
  body: any[] | string | undefined;
  exerciseBodyIndex: number;
  elementIndex: number | undefined;
  footer: any[] | undefined;
  header: any[] | undefined;
  problemUuid: string | undefined;
  template: number | undefined;
  type: string | undefined;
  url: string | undefined;
}

export default vue.extend<any, any, Computed, Props>({
  name: "ExerciseComponent",

  components: {
    ChatText,
    ExerciseHtmlText,
    ExerciseImage,
    ExercisePlainText,
    ExerciseSeparator,
    ExerciseTextArea
  },

  props: {
    body: {
      type: [Array, String],
      default: undefined
    },
    exerciseBodyIndex: {
      type: Number,
      default: undefined
    },
    elementIndex: {
      type: Number,
      default: undefined
    },
    footer: {
      type: Array,
      default: undefined
    },
    header: {
      type: Array,
      default: undefined
    },
    problemUuid: {
      type: String,
      default: undefined
    },
    template: {
      type: Number,
      default: 0
    },
    type: {
      type: String,
      default: undefined
    },
    url: {
      type: String,
      default: undefined
    }
  },

  computed: {
    dynamicComponent() {
      switch (this.type) {
        case "CHAT_TEXT":
          return "chat-text";
        case "CARD":
          return "jz-card";
        case "HTML_TEXT":
          return "exercise-html-text";
        case "IMAGE":
          return "exercise-image";
        case "PLAIN_TEXT":
          return "exercise-plain-text";
        case "SEPARATOR":
          return "exercise-separator";
        case "TEXT_AREA_INPUT":
          return "exercise-text-area";
        default:
          return "";
      }
    },

    dynamicProps() {
      const props = {
        exerciseBodyIndex: this.exerciseBodyIndex,
        elementIndex: this.elementIndex,
        problemUuid: this.reviewProblemUuid || this.problemUuid
      };

      switch (this.type) {
        case "HTML_TEXT":
          return {
            body: this.body,
            template: this.template,
            ...props
          };
        case "IMAGE":
          return {
            url: this.url
          };
        case "PLAIN_TEXT":
          return {
            body: this.body,
            ...props
          };
        default:
          return {
            ...props
          };
      }
    },

    headerElements() {
      if (this.header) return undefined;

      return this.header?.[0];
    },

    reviewProblemUuid() {
      const bodyElements = this.body;

      if (Array.isArray(this.body)) {
        const filteredBodyElements = bodyElements.filter((element: any) => {
          return !!element.problemUuid;
        });

        return filteredBodyElements?.[0]?.problemUuid;
      }

      return undefined;
    },

    recursiveComponent() {
      switch (this.type) {
        case "CARD":
          return true;
        default:
          return false;
      }
    }
  }
});
